import historicalNirCommuneDepartments from '@Common/validators/data/historical_nir_commune_departments.json';

export type HistoricalNirCommunePeriod = {
  /** Validity start (inclusive), YYYY-MM-DD */
  start: string;
  /** Validity end (exclusive), YYYY-MM-DD — null if still valid */
  end: string | null;
  /** Current successor commune INSEE code */
  current: string;
};

/**
 * Returns the current successor commune code when the NIR commune code was
 * historically valid at the given birth date and later moved to another department.
 * Returns null when there is no department-changing history for that code/date.
 */
export function findCurrentCommuneForHistoricalNir(
  nirCommuneCode: string,
  dateOfBirth: Date,
): string | null {
  const periods = (historicalNirCommuneDepartments as Record<string, HistoricalNirCommunePeriod[]>)[
    nirCommuneCode
  ];
  if (!periods) {
    return null;
  }

  const birthDate = toIsoDateString(dateOfBirth);
  for (const period of periods) {
    if (birthDate >= period.start && (period.end === null || birthDate < period.end)) {
      return period.current;
    }
  }

  return null;
}

/**
 * Department prefix used for postcode comparison.
 * Corsica 2A/2B maps to postcode prefix 20.
 */
export function departmentFromCommuneCode(communeCode: string): string {
  if (communeCode.startsWith('2A') || communeCode.startsWith('2B')) {
    return '20';
  }
  if (communeCode.startsWith('97') || communeCode.startsWith('98')) {
    return communeCode.slice(0, 3);
  }
  return communeCode.slice(0, 2);
}

function toIsoDateString(date: Date): string {
  return date.toISOString().slice(0, 10);
}
